import { Control, FieldValues, useController, UseControllerProps } from 'react-hook-form'
import { Input, InputProps } from '../../shadcn/Input'

export type ControlledInputProps<T extends FieldValues> = UseControllerProps<T> &
  Partial<Omit<InputProps, 'ref'>> & {
    className?: string
    inputClassName?: string
    label?: string
  }

export function ControlledInput<T extends FieldValues>({
  control,
  name,
  rules,
  defaultValue,
  className,
  inputClassName,
  label,
  ...rest
}: ControlledInputProps<T>) {
  const { field, fieldState } = useController({
    control,
    name,
    rules,
    defaultValue,
  })

  return (
    <div className={className}>
      <label className={label === undefined ? 'none' : ''}>{label}</label>
      <Input {...rest} onChange={field.onChange} value={String(field.value || '')} className={inputClassName} />
      {!!fieldState.error?.message && <span className={'text-rose-500'}>{fieldState.error?.message}</span>}
    </div>
  )
}
